import type { Infer } from 'superstruct';
import { assign, enums, integer, object, string } from 'superstruct';

import { parsableInteger, stringDate } from '@adflow/shared/util-superstruct';

import { HISTORY_ACTION_TYPES, HISTORY_ENTITY_TYPES } from './history-types';
import { ViewHistoryDataDto } from './view-history-log-data.dto';

const HistoryUserInfo = object({
	id: integer(),
	name: string(),
});

const HistoryEventInfo = object({
	id: parsableInteger(),
	entityType: enums(HISTORY_ENTITY_TYPES),
	entityId: parsableInteger(),
	action: enums(HISTORY_ACTION_TYPES),
});
export type HistoryEventInfo = Infer<typeof HistoryEventInfo>;

export const ViewHistoryDto = assign(
	HistoryEventInfo,
	object({
		user: HistoryUserInfo,
		data: ViewHistoryDataDto,
		createdAt: stringDate(),
	})
);
export type ViewHistoryDto = Infer<typeof ViewHistoryDto>;
